<p-confirmDialog
  key="deleteConfirm"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [blockScroll]="true"
  [position]="'center'"
  acceptLabel="Delete"
  acceptIcon="pi pi-trash"
  rejectLabel="Cancel"
  rejectIcon="pi pi-times"
  acceptButtonStyleClass="p-button-danger"
  rejectButtonStyleClass="p-button-secondary p-button-outlined"
  defaultFocus="reject"
  >

  <ng-template pTemplate="message" let-confirmation>
    <div class="flex items-start gap-3">
      <i class="pi pi-exclamation-triangle text-yellow-500" style="font-size: 3rem;"></i>
      <div class="flex-1">
        <div *ngIf="confirmation.itemName; else textMessage">
          <div class="mb-3">{{ confirmation.question || ('Are you sure you want to delete the following ' + confirmation.resourceType + '?') }}</div>
          <div class="mb-3 font-semibold">"{{ confirmation.itemName }}"</div>
          <div *ngIf="confirmation.additionalInfo" class="text-sm text-gray-600">{{ confirmation.additionalInfo }}</div>
        </div>
        <ng-template #textMessage>
          {{ confirmation.message }}
        </ng-template>
      </div>
    </div>
  </ng-template>

</p-confirmDialog>

<p-confirmDialog
  key="discardConfirm"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [blockScroll]="true"
  [position]="'center'"
  acceptLabel="Discard"
  acceptIcon="pi pi-times"
  rejectLabel="Cancel"
  rejectIcon="pi pi-times"
  acceptButtonStyleClass="p-button-danger"
  rejectButtonStyleClass="p-button-secondary p-button-outlined"
  defaultFocus="reject"
  >

  <ng-template pTemplate="message" let-confirmation>
    <div class="flex items-start gap-3">
      <i class="pi pi-exclamation-triangle text-yellow-500" style="font-size: 3rem;"></i>
      <div class="flex-1">
        {{ confirmation.message }}
      </div>
    </div>
  </ng-template>

</p-confirmDialog>
